import React from 'react';

import { SparklineComponent, Inject, SparklineTooltip } from "@syncfusion/ej2-react-charts";

//Changed to class componenet to fix resizing issue
class SparkLine extends React.PureComponent {
  render() {
    const {currentColor, id, height, width, color, type, data} = this.props
  return (
      <SparklineComponent
        id={id}
        height={height}
        widht={width}
        lineWidth={1}
        valueType="Numeric"
        fill={color}
        border={{ color: currentColor, width: 2 }}
        tooltipSettings={{ 
          visible: true,
          format: '${x} : data ${yval}',
          trackLineSettings: {
            visible: true
          },
        }}
        markerSettings={{ visible: ['All'], size: 2.5, fill: currentColor }}
        dataSource={data}
        xName="x"
        yName="yval"
        type={type}
      >
        <Inject services={[SparklineTooltip]} />
      </SparklineComponent>
  );
}}


export default SparkLine;